import { useQuery } from '@apollo/client';
import { MY_COACH_REQUESTS } from '../../apollo/queries/coachRequest';

const useMyCoachRequests = () => {
  const { data, loading, error, refetch } = useQuery(MY_COACH_REQUESTS, {
    pollInterval: 30000,
  });
  return {
    coachRequests: data?.myCoachRequests || [],
    loading,
    error,
    refetch,
  };
};

export default useMyCoachRequests;